import Notifications from './Notifications.vue'
import { notify } from '@/modules/notify'

const Notify = {
  install(app, args = {}) {
    if (this.installed) {
      return
    }

    this.installed = true
    this.params = args

    app.component(args.componentName || 'notifications', Notifications)

    const name = args.name || 'notify'

    app.config.globalProperties['$' + name] = notify
  }
}

export default Notify
